import { isDev } from "@workwave-tidal/core/base";
import { useEffect, useRef } from "react";
const emptyObject = {};
const __DEV__ = isDev();
function useFormName(_formApi, _updateMode, name, _fields, _config = emptyObject, _verbose) {
  const prevSource = useRef({ name });
  useEffect(() => {
    if (__DEV__) {
      const prevName = prevSource.current.name;
      if (name !== prevName) {
        console.warn(`[useCreateForm] -- Changing the Form name is a no-op. From [${prevName}] to [${name}].`);
      }
    }
  }, [name]);
  useEffect(() => void (prevSource.current = { name }), [name]);
}
export {
  useFormName
};
//# sourceMappingURL=useFormName.js.map
